import { z } from 'zod';
import type { AccountSearchResult } from '../../types/account.js';
import type { HcpSearchResult } from '../../types/hcp.js';
import type { KolSearchResult } from '../../types/kol.js';
import type { LocationItem } from '../../types/location.js';
import type { RepSearchResult } from '../../types/rep.js';

export namespace SearchKols {
  export type Request = {
    name?: string;
    lat?: number;
    lon?: number;
    brandIdentifier: string;
  };

  export type Response = {
    results: KolSearchResult[];
  };
}

export namespace SearchHcpsByName {
  export type Request = {
    name?: string;
    lat?: number;
    lon?: number;
    brandIdentifier: string;
    territoryId?: string;
  };

  export type Response = {
    results: HcpSearchResult[];
  };
}

export namespace SearchHcpsByLocation {
  export type Request = {
    lat: number;
    lon: number;
    brandIdentifier: string;
    territoryId?: string;
  };

  export type Response = {
    results: HcpSearchResult[];
  };
}

export namespace SearchLocation {
  export type Request = {
    query: string;
    lat?: number;
    lon?: number;
  };

  export type Response = {
    results: LocationItem[];
  };
}

export namespace SearchTags {
  export const requestSchema = z.object({
    query: z.string(),
  });

  export const responseSchema = z.object({
    results: z.array(
      z.object({
        id: z.number(),
        name: z.string(),
        metadata: z
          .object({
            canRemove: z.boolean().optional(),
            segmentIdentifier: z.string().nullable().optional(),
            journeyId: z.number().int().positive().nullable().optional(),
          })
          .optional(),
      })
    ),
  });

  //export type Request = z.infer<typeof requestSchema>;
  //export type Response = Required<z.infer<typeof responseSchema>>;
  export type Request = {
    query: string;
  };

  export type Response = {
    results: {
      id: number;
      name: string;
      metadata?: {
        canRemove?: boolean;
        segmentIdentifier?: string | null;
        journeyId?: number | null;
      };
    }[];
  };
}

export namespace SearchReps {
  export type Request = {
    name: string;
    brandIdentifier: string;
    territoryId?: string;
  };

  export type Response = {
    results: RepSearchResult[];
  };
}

export namespace SearchAccounts {
  export type Request = {
    name: string;
    brandIdentifier: string;
    territoryId?: string;
  };

  export type Response = {
    results: AccountSearchResult[];
  };
}
